import ArtworkFrame from '../../src/legacy/ArtworkFrame';
export default ArtworkFrame;
